import { render, staticRenderFns } from "./FieldArrayAccordionItem.vue?vue&type=template&id=3dcc09ba&scoped=true&"
import script from "./FieldArrayAccordionItem.vue?vue&type=script&lang=js&"
export * from "./FieldArrayAccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcc09ba",
  null
  
)

export default component.exports